import * as React from 'react'
import styled from 'styled-components'
import { Style } from '../../styles'

const Container = styled.div`
	display: flex;
	flex-direction: column;
`

export default class BalanceList extends React.PureComponent<{ children?: React.ReactNode }> {
	render() {
		return (
			<Container>
				{this.props.children}
			</Container>
		)
	}
}